fragment ContractFields on Contract {
  id
  title
  contractType
  purpose
  status
  legalEntity {
    id
    name
  }
  fpSignatoryName
  fpSignatoryRole
  counterpartyLegalName
  counterpartyWorkingName
  counterpartyEntityType
  counterpartyRegistrationNumber
  counterpartyJurisdiction
  counterpartySignatoryName
  counterpartySignatoryRole
  owner {
    id
    name
  }
  ownerLeft
  team {
    id
    name
  }
  parentContract {
    id
    title
  }
  childContracts {
    id
    title
    contractType
    status
  }
  executedOn
  effectiveOn
  expiresOn
  autoRenews
  renewalTermMonths
  noticePeriodAmount
  noticePeriodUnit
  noticeMethod
  noticeByOn
  noticeByOverridden
  deadlineOn
  renewalDecision
  renewalDecisionOn
  renewalDecisionByName
  lastRenewedOn
  value {
    minorUnit
    currency
  }
  valuePeriod
  billingFrequency
  paymentTerms
  priceIncreases
  governingLaw
  disputeResolution
  liabilityCap
  terminationForConvenience
  ipOwnership
  processesPersonalData
  personalDataDetails
  otherRequirements
  conflictsStatus
  conflictsDetails
  conflictsConfirmedByName
  conflictsConfirmedAt
  retentionRequirements
  retainUntilOn
  disposedOn
  disposalMethod
  terminatedOn
  notes
  notApplicableFields
  createdByName
  createdAt
  documents {
    id
    kind
    title
    datedOn
    signed
    originalFilename
    url
    uploadedByName
    createdAt
    extractionStatus
    extractionError
    extractedAt
    pageCount
    suggestions {
      field
      value
      quote
      clause
      page
      verified
      derived
    }
    referencedDocuments {
      title
      quote
      page
      verified
    }
  }
  reminders {
    id
    kind
    targetOn
    daysBefore
    status
    recipientName
    skipReason
    sentAt
    createdAt
  }
  upcomingReminderDates
}
